import { roundToTwo } from './roundToTwo';

export function divideBySafely(first: number, second: number): number {
  if (second === 0) {
    return 0;
  } else {
    return roundToTwo(first / second);
  }
}
